'use strict';

var cjs = {};

exports.__exports = cjs;
//# sourceMappingURL=index5.cjs.map
